export function useAddLabel(preOrder) {
  const { t } = useI18n()

  const addLabel = computed(() => {
    if (preOrder.value) {
      return t('product.picker.preOrder')
    }
    return t('product.picker.basket')
  })

  return {
    addLabel,
  }
}
